import type { Seo } from 'types/capi/shared';

type MetaDescriptor = Record<string, unknown>;

const ROBOTS_MAX_IMAGE_PREVIEW = 'max-image-preview:large';

function isRobotsTag(tag: MetaDescriptor) {
  return tag.name === 'robots';
}

export function formatAsMetaTags(metaTags: Record<string, string> = {}) {
  return Object.entries(metaTags).map(([key, value]) => {
    const metaKeyName = key.startsWith('og') ? 'property' : 'name';

    return {
      content: value,
      [metaKeyName]: key
    };
  });
}

export function formatForMeta(canonicalUrl: string, seo?: Seo) {
  const meta = [{ href: canonicalUrl, rel: 'canonical', tagName: 'link' }];

  if (!seo) return meta;

  const openGraph = formatAsMetaTags(seo.open_graph);
  const twitterCards = formatAsMetaTags(seo.twitter_cards);

  return [
    { title: seo.default.title },
    { content: seo.default.description, name: 'description' },
    { content: seo.default.thumbnail, name: 'thumbnail' },
    { content: 'app-id=1436712793', property: 'apple-itunes-app' },
    { content: ROBOTS_MAX_IMAGE_PREVIEW, name: 'robots' },
    ...meta,
    ...openGraph,
    ...twitterCards
  ];
}

export function addMetaNoIndex(meta: MetaDescriptor[]) {
  return [
    ...meta.filter((tag) => !isRobotsTag(tag)),
    { content: 'noindex', name: 'robots' }
  ];
}

export default {
  addMetaNoIndex,
  formatForMeta
};
